import { UI_SIZES } from '@modules/core/constants';

export const routeWrapperStyles = {
  container: {
    marginLeft: `${UI_SIZES.sideBar.width}`,
    width: `calc(100% - ${UI_SIZES.sideBar.width})`,
  },
};
